/* eslint-disable no-useless-computed-key */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useCallback, useRef } from 'react';
import clsx from 'clsx';
import { useDispatch, useSelector } from "react-redux";
import customStyles from "../../../../../assets/styles/customStyles";
import PrimaryCard from "../../../../Shared/components/Card/PrimaryCard";
import { Row, Col, Image, Space } from "antd";
import { Button, TextField, Box, Typography } from "@mui/material";
import SearchIcon from "../../../../../assets/images/icon_actions/Search Icon.svg";
import AddIcon from "../../../../../assets/images/icon_actions/Add Icon.svg";
import { PrimaryDrawer } from "../../../../Shared/components/Drawer/PrimaryDrawer";
//import FilterIcon from "../../../../../assets/images/icon_actions/Filter Icon.svg";
import MainHeader from "../../../../Shared/components/Header";
import crudActions from "../../../../CRUD/redux/actions";
import SettingsImg from "../../../../../assets/images/icon_menus/SettingsIcon.json";
import { UnitConversionsTable } from "./UnitConversionsTable";
import usePrevious from "../../../../Shared/components/Previous";
import { useParams, NavLink } from "react-router-dom";
import actions from "../../redux/actions";
import { toast } from 'react-toastify';
import ExportIcon from "../../../../../assets/images/icon_actions/Export.svg";
import ImportIcon from "../../../../../assets/images/icon_actions/Import.svg";
import { ImportExport } from '../../../../Shared/components/ImportExport';
import DeleteModal from "../../../../Shared/components/DeleteModal";
import qucikLinksActions from "../../../../Dashboard/redux/actions";
import { AutoCompleteComponent } from "../../../../Shared/components/AutoCompleteComponent";
import { QuickLinks } from "../../../../Shared/components/BreadCrumbNew/QuickLinks";
import { emptyValidation } from "../../../../../helpers/validation";
import { checkCRUDPermission, checkComponentPermission } from '../../../../../helpers/utilities';
import ClearIcon from "../../../../../assets/images/icon_actions/Clear Icon.svg";

const UnitConversions = (props) => {
    const [visible, setVisible] = useState(false);
    const { createDetails, createError, createLoader, getList, getData, editLoader, editDetails, editError } = useSelector(state => state.crudReducer);
    const { unitMesurementdetails, unitClassdetails } = useSelector(state => state.productSetupReducer);
    const { roleManagement } = useSelector(state => state.authReducer);
    const [addMore, setAddMore] = useState(false);
    const prevCreateDetails = usePrevious(createDetails);
    const prevCreateError = usePrevious(createError);
    const prevEditDetails = usePrevious(editDetails);
    const { moduleType } = props;
    const prevEditError = usePrevious(editError);
    const [search, setSearch] = useState('');
    const prevSearch = usePrevious(search);
    const [skip, setSkip] = useState(0);
    const timeoutRef = useRef(null);
    const limit = 25;
    const [sortOrder, setSortOrder] = useState("desc");
    const [sortBy, setSortBy] = useState("id");
    const [loadMore, setLoadMore] = useState(false);
    const [loadMoreContent, setLoadMoreContent] = useState(false);
    const [importVisible, setImportVisible] = useState(false);
    const [conversionId, setConversionId] = useState('');
    const [conversion, setConversion] = useState('');
    const [form, setForm] = useState({});
    const [formRelation, setFormRelation] = useState({});
    const [error, setError] = useState({});
    const [deleteModal, setDeleteModal] = useState(false);
    const [view, setView] = useState(false);
    const [toUnit, setToUnit] = useState([]);
    const [filterClassId, setFilterClassId] = useState('');
    const { filterParamsClassId } = useParams();

    let menus = [
        {
            "name": "Unit Class",
            "link": "/younote-admin/setup/units/unit-class"
        },
        {
            "name": "Unit of Measurement",
            "link": "/younote-admin/setup/units/unit-measurement"
        },
        {
            "name": "Product Unit Conversion",
            "link": "/product/setup/units/product-unit-conversions"
        }
    ];

    const handleOpen = () => {
        setConversionId('');
        setVisible(true);
        emptyState();
        emptyStateInput();
    };

    const handleClose = () => {
        setVisible(false);
        emptyState();
        emptyStateInput();

    };
    const emptyState = () => {
        setError({});
    };

    const emptyStateInput = () => {
        setForm({
            "additionalFactor": parseFloat(0.00).toFixed(2),
            "conversionFactor": parseFloat(1.000000).toFixed(6)
        });
        setFormRelation({});
    };

    const dispatch = useDispatch();

    const onExport = () => {

    }


    useEffect(() => {
        if ((prevSearch !== undefined && search && search.length > 2 && prevSearch !== search) || (prevSearch !== undefined && search === '' && prevSearch !== search)) {
            if (timeoutRef.current !== null) {
                clearTimeout(timeoutRef.current);
            }
            if (search === '') {
                dispatchFilter(filterClassId, sortBy, sortOrder);
            } else {
                timeoutRef.current = setTimeout(() => {
                    timeoutRef.current = null;
                    dispatchFilter(filterClassId, sortBy, sortOrder);
                }, 500);
            }
        }
    }, [search]);

    useEffect(() => {
        //if (roleManagement !== '' && checkViewPermission('Unit Conversions', history, 'Younote Admin')) {
        loadTasks();
        // }
    }, []);

    const prevGetData = usePrevious(getData); useEffect(() => {
        if (loadMore && getData === '') {
            setLoadMoreContent(false);
            setLoadMore(true);
        }
        if (prevGetData !== undefined && getData && prevGetData !== getData) {
            const timer = setTimeout(() => {
                if (getData && Array.isArray(getData) && getData.length > 0) {
                    setLoadMore(true);
                    if (getData.length < limit) {
                        setLoadMoreContent(false);
                    } else {
                        setLoadMoreContent(true);
                    }
                } else {
                    setLoadMoreContent(false);
                    setLoadMore(true);
                }
            });

            return () => {
                clearTimeout(timer);
            };
        }
    }, [getData]);

    const dispatchFilter = (filterClassId, sortBy, sortOrder, skip = 0) => {
        if (skip === 0) {
            setLoadMore(false);
            setLoadMoreContent(false);
        }
        let filter = { or: [] };
        if (search !== '') {
            filter['or'].push({ conversionFactor: { like: '%' + search.trim() + '%' } });
            filter['or'].push({ additionalFactor: { like: '%' + search.trim() + '%' } });
        }

        if (filterClassId) {
            filter['or'].push({ unitId: filterClassId });

        }
        console.log(filter.or)
        setSkip(skip);
        dispatch({
            type: crudActions.GET_DETAILS_START,
            url: 'unit-conversions',
            skip: skip,
            filter: {
                where: !filter.or || filter.or.length === 0 ? {} : filter,
                order: sortBy + ' ' + sortOrder,
                limit: limit,
                skip: skip,
            }
        });
    }

    const handleUnitClassId = (value) => {
        setFilterClassId(value);
        dispatchFilter(value, sortBy, sortOrder);
    }

    const loadTasks = useCallback(() => {
        if (filterParamsClassId !== undefined) {
            setFilterClassId(filterParamsClassId);
        }
        dispatchFilter(filterParamsClassId, sortBy, sortOrder);
        dispatch({
            type: actions.UNITCLASS_DETAILS_START, url: 'unitclass', filter: {
                order: 'id  desc'
            }
        });
        dispatch({
            type: actions.UNITMESUREMENT_DETAILS_START, url: 'unit', filter: {
                order: 'id  desc'
            }
        });

        setTimeout(function () {
            dispatch({ type: qucikLinksActions.QUICKLINKS_START, menus: menus, toggle: true, component: "Unit Conversions" });
        }, 200)
    });

    const handleSubmit = (e) => {
        e.preventDefault();
        let emptyUnitId = emptyValidation('Unit', form.unitId, 'dropDown');
        let emptyToUnitId = emptyValidation('To Unit', form.toUnitId, 'dropDown');
        let emptyConversionFactor = emptyValidation('Conversion Factor', form.conversionFactor);
        let emptyAdditionalFactor = emptyValidation('Additional Factor', form.additionalFactor);
        emptyState();
        if (emptyUnitId.isValid && emptyToUnitId.isValid && emptyConversionFactor.isValid
            && emptyAdditionalFactor.isValid
        ) {
            let data = Object.fromEntries(Object.entries(form).filter(([_, v]) => v !== null && v !== ''));
            if (data['conversionFactor']) {
                data['conversionFactor'] = parseFloat(data['conversionFactor']);
            }
            if (data['additionalFactor']) {
                data['additionalFactor'] = parseFloat(data['additionalFactor']);
            }

            dispatch({
                type: conversionId ? crudActions.EDIT_DETAILS_START : crudActions.CREATE_DETAILS_START,
                url: 'unit-conversions',
                title: 'Unit Conversions',
                id: conversionId,
                details: data
            });
        } else {
            setError({
                'unitId': emptyUnitId.errors,
                'toUnitId': emptyToUnitId.errors,
                'conversionFactor': emptyConversionFactor.errors,
                'additionalFactor': emptyAdditionalFactor.errors,
            })
        }
    }

    const onEdit = (data, view = false) => {
        handleOpen();
        setConversionId(data.id);
        setView(view);
        setForm({
            'unitId': data?.unitId,
            'toUnitId': data?.toUnitId,
            'unitClassId': data?.unitClassId,
            'conversionFactor': data?.conversionFactor,
            'additionalFactor': data?.additionalFactor
        });

        setFormRelation({
            'unit': data?.unit?.name,
            'toUnit': data?.toUnit?.name
        });
    }

    const handleOpenImport = () => {
        setImportVisible(true);
    }

    const handleImportClose = () => {
        setImportVisible(false);
    }

    useEffect(() => {
        if (prevCreateDetails !== undefined && createDetails && prevCreateDetails !== createDetails) {
            dispatchFilter(filterClassId, sortBy, sortOrder);
            setVisible(false);
            toast.dismiss();
            toast(createDetails);
            emptyStateInput();
            if (addMore) {
                setAddMore(false);
                setTimeout(function () {
                    setVisible(true);
                }, 500)
            }
        } else if (prevCreateError !== undefined && createError && prevCreateError !== createError) {
            let text = createError.error.message;
            toast.dismiss();
            toast.error(text);
        }
    }, [createDetails, createError]);


    useEffect(() => {
        if (prevEditDetails !== undefined && editDetails && prevEditDetails !== editDetails) {
            dispatchFilter(filterClassId, sortBy, sortOrder);
            handleClose();
            toast.dismiss();
            toast(editDetails);
        } else if (prevEditError !== undefined && editError && prevEditError !== editError) {
            let message = editError.error.message;
            toast.dismiss();
            toast.error(message);

        }
    }, [editDetails, editError]);

    const handleAddMore = (e) => {
        handleSubmit(e);
        setAddMore(true);
    }

    const changeHandler = (e, name = '') => {
        if (name !== '') {
            if (name === 'unitId') {
                let a = unitMesurementdetails && unitMesurementdetails.filter(function (el) { return el.id === e });
                setToUnit(unitMesurementdetails && unitMesurementdetails.filter(function (el) { return el.unitClassId === a[0]?.unitClassId }))
                setForm({
                    ...form,
                    'unitClassId': a[0]?.unitClassId,
                    'unitId': e
                });
            } else {
                setForm({
                    ...form,
                    [name]: e,
                });
            }
        } else {
            setForm({
                ...form,
                [e.target.name]: e.target.type === 'number' && e.target.value !== '' ? parseFloat(e.target.value) : e.target.value
            });
        }
    }

    const requestSort = (sortBy, sortOrder) => {
        setSortBy(sortBy);
        setSortOrder(sortOrder);
        dispatchFilter(filterClassId, sortBy, sortOrder);
    }

    const [iconAnimation, setIconAnimation] = useState(false);

    const loadMoreTask = () => {
        let s = skip + limit;
        dispatchFilter(filterClassId, sortBy, sortOrder, s);
    }

    const customObject = (details, id) => {
        let a = details && details.filter(function (el) { return el.id === parseInt(id) });
        if (a && a?.length !== 0) {
            return a[0];
        }
        return [];
    }

    const onDelete = (data) => {
        setDeleteModal(true);
        setConversionId(data.id);
        setConversion(data.id);
    }


    const handleDeleteModal = (value) => {
        setDeleteModal(value);
    }

    const classes = customStyles();
    return (
        <React.Fragment>
            {
                moduleType === 'Admin' ? <MainHeader {...props} img={SettingsImg} title={'Admin'}
                    links={[{ 'label': 'Admin', 'link': '/admin' }, { 'label': 'Unit', 'link': '/admin/setup/units/unit-class' }, { 'label': 'Unit Conversions', 'link': '' }]} /> :
                    <MainHeader {...props} img={SettingsImg} title={'Younote Admin'}
                        links={[{ 'label': 'Younote Admin', 'link': '/younote-admin' }, { 'label': 'Unit', 'link': '/younote-admin/setup/units/unit-class' }, { 'label': 'Unit Conversions', 'link': '' }]} />}
            <div className={clsx(classes.margin40, classes.listTableMargin, classes.customerLabelNone)}>
                <PrimaryCard
                    title={'Unit Conversions'}
                    component={
                        <>
                            <Row align="middle" className={classes.marginBottom20}>
                                <Col xxl={6} xl={7} lg={8} md={10} sm={13} xs={24}>
                                    {
                                        roleManagement !== '' && checkComponentPermission('Unit Conversions', 'Action', 'Search') &&
                                        <div className={clsx(classes.searchAnimation, { [classes.iconAnimation]: iconAnimation || search !== '' })}>
                                            <TextField autoComplete='one-time-code'
                                                placeholder='Search'
                                                type='search'
                                                value={search}
                                                className={classes.comInput}
                                                variant={'standard'}
                                                onChange={(e) => setSearch(e.target.value)}
                                                fullWidth
                                                onFocus={() => setIconAnimation(true)}
                                                onBlur={() => setIconAnimation(false)}
                                            />
                                            <Image
                                                src={SearchIcon}
                                                preview={false}
                                            />
                                            {
                                                search && <NavLink to="#" onClick={() => setSearch('')} className={classes.searchClear}>
                                                    <Image
                                                        src={ClearIcon}
                                                        preview={false}
                                                    />
                                                </NavLink>
                                            }
                                        </div>
                                    }
                                </Col>
                                <Col xxl={18} xl={17} lg={16} md={14} sm={11} xs={24} className={clsx(classes.textAlignRight, classes.removeUnderline, classes.vertiCalScrollOverFlowParent)}>
                                    <div className={classes.vertiCalScrollOverFlow}>
                                        <Space direction="horizontal" align="center" >
                                            {
                                                roleManagement !== '' && checkComponentPermission('Unit Conversions', 'Action', 'All Dropdown') &&
                                                <AutoCompleteComponent
                                                    customLabel={"All"}
                                                    heads={[{ 'key': 'name', 'name': 'Name' }]}
                                                    customClasses={classes.customFilterNone}
                                                    details={unitMesurementdetails}
                                                    parentValue={customObject(unitMesurementdetails, filterClassId)}
                                                    position={"bottom"}
                                                    variant={'outlined'}
                                                    onChangeText={(data) => {
                                                        if (data === '') {
                                                            handleUnitClassId('')
                                                        }
                                                    }}
                                                    onChange={(data) => {
                                                        handleUnitClassId(data?.id)
                                                    }}
                                                />
                                            }
                                            {
                                                roleManagement !== '' && checkComponentPermission('Unit Conversions', 'Action', 'Export') &&
                                                <NavLink
                                                    to={"#"}
                                                    onClick={() => onExport()}
                                                    className={clsx(classes.customLink)}>
                                                    <Image
                                                        src={ExportIcon}
                                                        preview={false}
                                                        className={clsx(classes.antImage)}
                                                    /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Export</span>
                                                </NavLink>
                                            }
                                            {
                                                roleManagement !== '' && checkComponentPermission('Unit Conversions', 'Action', 'Import') &&
                                                <NavLink
                                                    to={"#"}
                                                    onClick={() => handleOpenImport()}
                                                    className={clsx(classes.customLink)}
                                                >
                                                    <Image
                                                        src={ImportIcon}
                                                        preview={false}
                                                        className={clsx(classes.antImage)}
                                                    /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Import</span>
                                                </NavLink>
                                            }
                                            {
                                                roleManagement !== '' && (checkCRUDPermission('Unit Conversions', 'create', 'Younote Admin')
                                                    || checkCRUDPermission('Unit Conversions', 'create', 'Admin')) &&
                                                <NavLink to={"#"}
                                                    onClick={() => onEdit({}, false)}
                                                    className={clsx(classes.customLink)}>
                                                    <Image
                                                        src={AddIcon}
                                                        preview={false}
                                                        className={clsx(classes.antImage)}
                                                    /><span className={clsx(classes.addLink, classes.color, classes.bold)}>Add Unit Conversion</span>
                                                </NavLink>
                                            }
                                            {
                                                roleManagement !== '' && checkComponentPermission('Unit Conversions', 'Action', 'Filter') &&
                                                <></>
                                            }
                                        </Space>
                                    </div>
                                </Col>
                            </Row>
                            <UnitConversionsTable
                                onEdit={(data, view) => onEdit(data, view)}
                                onDelete={(data) => onDelete(data)}
                                details={getList}
                                loadMore={loadMore}
                                loadMoreContent={loadMoreContent}
                                loadMoreTask={() => loadMoreTask()}
                                sortOrder={sortOrder}
                                sortBy={sortBy}
                                roleManagement={roleManagement}
                                onRequestSort={(sortBy, sortOrder) => requestSort(sortBy, sortOrder)} />
                        </>
                    }
                />
            </div>
            <PrimaryDrawer
                anchor={'right'}
                open={visible}
                variant={'temporary'}
                width={'495px'}
                handleClose={() => handleClose()}
                title={`${conversionId ? `${view ? 'View' : 'Edit'}` : 'Add New'} Unit Conversion`}
                className={clsx(classes.closeBackGround, classes.width100P)}
                component={
                    <Box
                        className={clsx(classes.customForm, classes.removeUnderline)}
                        component="form"
                        autoComplete='off'
                        onSubmit={(e) => handleSubmit(e)}>
                        <div className={classes.customFormFlex}>
                            <Row gutter={20}>
                                <Col xxl={8} xl={8} lg={8} md={8} sm={8} xs={24} className={classes.positionRelative}>
                                    <div className={classes.unitFor}>For 1</div>
                                    <div className={classes.unitForText}>
                                        {
                                            view ?
                                                <>
                                                    <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>From Unit</Typography>
                                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{formRelation.unit}</Typography>
                                                </> :
                                                <AutoCompleteComponent
                                                    name={["From Unit ", <span key={'From Unit'} className={classes.colorRedRequired}> *</span>]}
                                                    heads={[{ 'key': 'name', 'name': 'Unit' },
                                                    { 'key': 'description', 'name': 'Description' }]}
                                                    details={unitMesurementdetails}
                                                    customClasses={classes.margin20t}
                                                    parentValue={customObject(unitMesurementdetails, form.unitId)}
                                                    onChange={(data) => changeHandler(data.id, 'unitId')}
                                                    position={"bottom"}
                                                    parentError={error.unitId}
                                                />
                                        }
                                    </div>
                                </Col>
                                <Col xxl={8} xl={8} lg={8} md={8} sm={8} xs={24}>
                                    {
                                        view ?
                                            <>
                                                <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Conversion  Factor</Typography>
                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form.conversionFactor}</Typography>
                                            </> :
                                            <TextField autoComplete='one-time-code'
                                                label='Conversion  Factor'
                                                variant={'standard'}
                                                type={'number'}
                                                className={clsx(classes.margin20t)}
                                                error={error.conversionFactor ? true : false}
                                                helperText={error.conversionFactor}
                                                name={"conversionFactor"}
                                                fullWidth
                                                onWheel={(e) => e.target.blur()}
                                                value={form.conversionFactor ? form.conversionFactor : ''}
                                                InputProps={{
                                                    classes: {
                                                        input: classes.textFieldColor,
                                                    },
                                                    step: "any"
                                                }}
                                                InputLabelProps={{
                                                    className: classes.textFieldLableColorCustom,
                                                }}
                                                onChange={(e) => changeHandler(e)}
                                            />
                                    }
                                </Col>
                                <Col xxl={8} xl={8} lg={8} md={8} sm={8} xs={24}>
                                    {
                                        view ?
                                            <>
                                                <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>To Unit</Typography>
                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{formRelation.toUnit}</Typography>
                                            </> :
                                            <AutoCompleteComponent
                                                name={["To Unit ", <span key={'To Unit'} className={classes.colorRedRequired}> *</span>]}
                                                heads={[{ 'key': 'name', 'name': 'Unit' },
                                                { 'key': 'description', 'name': 'Description' }]}
                                                details={toUnit}
                                                parentValue={customObject(toUnit, form.toUnitId)}
                                                onChange={(data) => changeHandler(data.id, 'toUnitId')}
                                                position={"bottom"}
                                                customClasses={classes.margin20t}
                                                parentError={error.toUnitId}
                                            />
                                    }
                                </Col>
                                <Col xxl={8} xl={8} lg={8} md={8} sm={8} xs={24}>
                                    <Typography variant={'subtitle1'} className={clsx({ [classes.margin30t]: view }, classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Unit Class</Typography>
                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>
                                        {form.unitId ? (
                                            unitClassdetails && unitClassdetails.length > 0 && unitClassdetails.filter(uc => uc.id === form.unitClassId).map(filteredUnits => (
                                                <React.Fragment key={filteredUnits?.id}>
                                                    {filteredUnits?.name}
                                                </React.Fragment>
                                            )))
                                            : '---'}
                                    </Typography>
                                </Col>
                                <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                                    {
                                        view ?
                                            <>
                                                <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Addition Factor</Typography>
                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form.additionalFactor}</Typography>
                                            </> :
                                            <TextField autoComplete='one-time-code'
                                                label='Addition Factor'
                                                variant={'standard'}
                                                type={'number'}
                                                className={clsx(classes.margin20t)}
                                                error={error.additionalFactor ? true : false}
                                                helperText={error.additionalFactor}
                                                name={"additionalFactor"}
                                                fullWidth
                                                onWheel={(e) => e.target.blur()}
                                                value={form.additionalFactor}
                                                InputProps={{
                                                    classes: {
                                                        input: classes.textFieldColor,
                                                    },
                                                    step: "any"
                                                }}
                                                InputLabelProps={{
                                                    className: classes.textFieldLableColorCustom,
                                                }}
                                                onChange={(e) => changeHandler(e)}
                                            />
                                    }
                                </Col>
                                {
                                    form.unitId && form.toUnitId && form.conversionFactor &&
                                    <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                        <Typography variant={'subtitle1'} className={clsx(classes.addressSmall, classes.bold, classes.margin20t, classes.fonSize13)}>Note:</Typography>
                                        <div className={clsx(classes.unitNote, classes.bold)}>
                                            {`1 ${customObject(unitMesurementdetails, parseInt(form.unitId))?.name} = ${(parseFloat(form.conversionFactor) + parseFloat(form.additionalFactor))} ${customObject(unitMesurementdetails, parseInt(form.toUnitId))?.name}`}
                                        </div>
                                    </Col>
                                }
                            </Row>
                        </div>
                        <div className={clsx(classes.btnParent)}>
                            {
                                !view ?
                                    <Space direction="horizontal" align="center" size={[10, 10]}>
                                        <Button
                                            key="save"
                                            type='submit'
                                            color='primary'
                                            variant="contained"
                                            className={clsx(classes.modalBtn, { [classes.loading]: createLoader || editLoader })}>
                                            {
                                                conversionId ? 'Update & Close' : 'Save & Close'
                                            }
                                        </Button>
                                        {
                                            !conversionId &&
                                            <Button
                                                key="add"
                                                color='primary'
                                                variant="contained"
                                                className={clsx(classes.AddMoreBtn, { [classes.loading]: createLoader || editLoader })}
                                                onClick={(e) => handleAddMore(e)}>
                                                Add More
                                            </Button>
                                        }
                                    </Space> :
                                    <>
                                        {
                                            roleManagement !== '' && (checkCRUDPermission('Unit Conversions', 'edit', 'Younote Admin') || checkCRUDPermission('Unit Conversions', 'edit', 'Admin')) && <NavLink to={'#'} className={clsx(classes.modalBtn)} onClick={() => setView(false)}>Edit</NavLink>
                                        }
                                    </>
                            }
                        </div>
                    </Box>
                }
            />
            <DeleteModal onClose={(v) => handleDeleteModal(v)} id={conversionId} loadTasks={() => dispatchFilter(filterClassId, sortBy, sortOrder)}
                name={conversion} url={'unit-conversions'}
                title={'Unit Convesions'} visible={deleteModal}
            />
            <ImportExport
                handleClose={() => handleImportClose()}
                visible={importVisible}
                title={'Unit Convesions'}
                type={'import'}
                details={[]}
                loadTasks={() => { dispatchFilter(filterClassId, sortBy, sortOrder) }}
            />
            <QuickLinks menus={menus} component={"Unit Conversions"}></QuickLinks>
        </React.Fragment>
    )
}
export default UnitConversions